// Page guides: one entry per dashboard route that has a written guide.
//
// The value is the key under `TELETEL_PAGE_GUIDE.PAGES` in the ar/en locale
// files, where the guide's whole text lives (purpose, benefits, parts of the
// page, step-by-step tasks, tips, who can see it). Several routes may share one
// guide when they are views of the same page (all contacts, active, segment,
// label). A route absent from this map gets the "not written yet" notice.
//
// 2026-09-19: first prototype on the contacts list, then rolled out to every
// page that renders content (redirect-only routes are left out on purpose).
// Add a page = write its guide in both locale files, then map its route names
// here.
export const PAGE_GUIDES = Object.freeze({
  // TEAM_PRESENCE
  teletel_team_presence: 'TEAM_PRESENCE',
  // ADVISOR
  teletel_advisor: 'ADVISOR',
  // ASSISTANT
  teletel_assistant: 'ASSISTANT',
  // BRANDING
  teletel_branding: 'BRANDING',
  // CALL_CENTER
  teletel_call_center: 'CALL_CENTER',
  // CAMPAIGNS_LIVECHAT
  campaigns_livechat_index: 'CAMPAIGNS_LIVECHAT',
  campaigns_ongoing_index: 'CAMPAIGNS_LIVECHAT',
  // CAMPAIGNS_REPORTS
  campaigns_reports_index: 'CAMPAIGNS_REPORTS',
  // CAMPAIGNS_SMS
  campaigns_sms_index: 'CAMPAIGNS_SMS',
  // CAMPAIGNS_WHATSAPP
  campaigns_whatsapp_index: 'CAMPAIGNS_WHATSAPP',
  campaigns_whatsapp_new: 'CAMPAIGNS_WHATSAPP_NEW',
  // COMPANIES
  companies_dashboard_index: 'COMPANIES',
  // COMPANY_DETAILS
  companies_dashboard_show: 'COMPANY_DETAILS',
  // CONTACTS
  contacts_dashboard_index: 'CONTACTS',
  contacts_dashboard_segments_index: 'CONTACTS',
  contacts_dashboard_labels_index: 'CONTACTS',
  contacts_dashboard_active: 'CONTACTS',
  contacts_lifecycle_board: 'LIFECYCLE_BOARD',
  // CONTACT_DETAILS
  contacts_edit: 'CONTACT_DETAILS',
  contacts_edit_label: 'CONTACT_DETAILS',
  contacts_edit_segment: 'CONTACT_DETAILS',
  // CONVERSATIONS
  conversation_mentions: 'CONVERSATIONS',
  conversation_participating: 'CONVERSATIONS',
  conversation_through_inbox: 'CONVERSATIONS',
  conversation_through_mentions: 'CONVERSATIONS',
  conversation_through_participating: 'CONVERSATIONS',
  conversation_through_unattended: 'CONVERSATIONS',
  conversation_unattended: 'CONVERSATIONS',
  conversations_through_folders: 'CONVERSATIONS',
  conversations_through_label: 'CONVERSATIONS',
  conversations_through_team: 'CONVERSATIONS',
  folder_conversations: 'CONVERSATIONS',
  home: 'CONVERSATIONS',
  teletel_delivery_unknowns: 'CONVERSATIONS',
  inbox_conversation: 'CONVERSATIONS',
  inbox_dashboard: 'CONVERSATIONS',
  label_conversations: 'CONVERSATIONS',
  team_conversations: 'CONVERSATIONS',
  // FLOWS_BUILDER
  teletel_flows_edit: 'FLOWS_BUILDER',
  teletel_flows_new: 'FLOWS_BUILDER',
  // FLOWS_RUNS
  teletel_flows_runs: 'FLOWS_RUNS',
  // FLOWS_TEMPLATES
  teletel_flows_templates: 'FLOWS_TEMPLATES',
  // HELPCENTER_ARTICLES
  portals_articles_index: 'HELPCENTER_ARTICLES',
  portals_categories_articles_index: 'HELPCENTER_ARTICLES',
  // HELPCENTER_ARTICLE_EDITOR
  portals_articles_edit: 'HELPCENTER_ARTICLE_EDITOR',
  portals_articles_new: 'HELPCENTER_ARTICLE_EDITOR',
  portals_categories_articles_edit: 'HELPCENTER_ARTICLE_EDITOR',
  portals_categories_articles_new: 'HELPCENTER_ARTICLE_EDITOR',
  // HELPCENTER_CATEGORIES
  portals_categories_index: 'HELPCENTER_CATEGORIES',
  // HELPCENTER_LOCALES
  portals_locales_index: 'HELPCENTER_LOCALES',
  // HELPCENTER_PORTALS
  portals_index: 'HELPCENTER_PORTALS',
  portals_new: 'HELPCENTER_PORTALS',
  // HELPCENTER_SETTINGS
  portals_settings_index: 'HELPCENTER_SETTINGS',
  // INBOX_VIEW
  inbox_view: 'INBOX_VIEW',
  inbox_view_conversation: 'INBOX_VIEW',
  // INTEGRATIONS
  settings_applications: 'INTEGRATIONS',
  // INTEGRATIONS_APP
  settings_applications_integration: 'INTEGRATIONS_APP',
  // INTEGRATIONS_DASHBOARD_APPS
  settings_integrations_dashboard_apps: 'INTEGRATIONS_DASHBOARD_APPS',
  // INTEGRATIONS_GUIDES
  settings_integrations_teletel_guide: 'INTEGRATIONS_GUIDES',
  // INTEGRATIONS_LINEAR
  settings_integrations_linear: 'INTEGRATIONS_LINEAR',
  // INTEGRATIONS_NOTION
  settings_integrations_notion: 'INTEGRATIONS_NOTION',
  // INTEGRATIONS_SHOPIFY
  settings_integrations_shopify: 'INTEGRATIONS_SHOPIFY',
  // INTEGRATIONS_SLACK
  settings_integrations_slack: 'INTEGRATIONS_SLACK',
  // INTEGRATIONS_WEBHOOKS
  settings_integrations_webhook: 'INTEGRATIONS_WEBHOOKS',
  teletel_integration_controls: 'INTEGRATIONS_WEBHOOKS',
  // LIFECYCLE_SETTINGS
  teletel_lifecycle_settings: 'LIFECYCLE_SETTINGS',
  // META_GUIDE
  teletel_meta_guide: 'META_GUIDE',
  teletel_meta: 'META_STATUS',
  // NOTIFICATIONS
  notifications_index: 'NOTIFICATIONS',
  // PROFILE_SETTINGS
  profile_settings_index: 'PROFILE_SETTINGS',
  profile_settings_mfa: 'PROFILE_SETTINGS',
  // REMINDERS
  teletel_reminders_index: 'REMINDERS',
  // REPORTS_AGENTS
  agent_reports: 'REPORTS_AGENTS',
  agent_reports_index: 'REPORTS_AGENTS',
  agent_reports_show: 'REPORTS_AGENTS',
  // REPORTS_BOT
  bot_reports: 'REPORTS_BOT',
  // REPORTS_CONVERSATIONS
  conversation_reports: 'REPORTS_CONVERSATIONS',
  // REPORTS_CSAT
  csat_reports: 'REPORTS_CSAT',
  // REPORTS_EFFICIENCY
  employee_efficiency: 'REPORTS_EFFICIENCY',
  // REPORTS_INBOXES
  inbox_reports: 'REPORTS_INBOXES',
  inbox_reports_index: 'REPORTS_INBOXES',
  inbox_reports_show: 'REPORTS_INBOXES',
  // REPORTS_LABELS
  label_reports: 'REPORTS_LABELS',
  label_reports_index: 'REPORTS_LABELS',
  label_reports_show: 'REPORTS_LABELS',
  // REPORTS_LIFECYCLE
  lifecycle_reports: 'REPORTS_LIFECYCLE',
  // REPORTS_OVERVIEW
  account_overview_reports: 'REPORTS_OVERVIEW',
  // REPORTS_SLA
  sla_reports: 'REPORTS_SLA',
  // REPORTS_TEAMS
  team_reports: 'REPORTS_TEAMS',
  team_reports_index: 'REPORTS_TEAMS',
  team_reports_show: 'REPORTS_TEAMS',
  // SETTINGS_AGENTS
  agent_list: 'SETTINGS_AGENTS',
  // SETTINGS_AGENT_BOTS
  agent_bots: 'SETTINGS_AGENT_BOTS',
  // SETTINGS_ASSIGNMENT_POLICIES
  agent_assignment_policy_create: 'SETTINGS_ASSIGNMENT_POLICIES',
  agent_assignment_policy_edit: 'SETTINGS_ASSIGNMENT_POLICIES',
  agent_assignment_policy_index: 'SETTINGS_ASSIGNMENT_POLICIES',
  agent_capacity_policy_create: 'SETTINGS_ASSIGNMENT_POLICIES',
  agent_capacity_policy_edit: 'SETTINGS_ASSIGNMENT_POLICIES',
  agent_capacity_policy_index: 'SETTINGS_ASSIGNMENT_POLICIES',
  assignment_policy_index: 'SETTINGS_ASSIGNMENT_POLICIES',
  // SETTINGS_ATTRIBUTES
  attributes_list: 'SETTINGS_ATTRIBUTES',
  // SETTINGS_AUDIT_TRAIL
  auditlogs_list: 'SETTINGS_AUDIT_TRAIL',
  teletel_audit_trail: 'SETTINGS_AUDIT_TRAIL',
  // SETTINGS_AUTOMATION
  automation_list: 'SETTINGS_AUTOMATION',
  teletel_flows_list: 'SETTINGS_AUTOMATION',
  teletel_flows_wrapper: 'SETTINGS_AUTOMATION',
  // SETTINGS_CANNED
  canned_list: 'SETTINGS_CANNED',
  // SETTINGS_CONVERSATION_WORKFLOW
  conversation_workflow_index: 'SETTINGS_CONVERSATION_WORKFLOW',
  // SETTINGS_GENERAL
  general_settings_index: 'SETTINGS_GENERAL',
  // SETTINGS_INBOXES
  settings_inbox_finish: 'SETTINGS_INBOXES',
  settings_inbox_list: 'SETTINGS_INBOXES',
  settings_inbox_new: 'SETTINGS_INBOXES',
  settings_inbox_show: 'SETTINGS_INBOXES',
  settings_inboxes_add_agents: 'SETTINGS_INBOXES',
  settings_inboxes_page_channel: 'SETTINGS_INBOXES',
  // SETTINGS_LABELS
  labels_list: 'SETTINGS_LABELS',
  labels_wrapper: 'SETTINGS_LABELS',
  // SETTINGS_MACROS
  macros_edit: 'SETTINGS_MACROS',
  macros_new: 'SETTINGS_MACROS',
  macros_wrapper: 'SETTINGS_MACROS',
  // SETTINGS_ROLES
  custom_roles_list: 'SETTINGS_ROLES',
  teletel_roles: 'SETTINGS_ROLES',
  // SETTINGS_SECURITY
  security_settings_index: 'SETTINGS_SECURITY',
  // SETTINGS_SLA
  sla_list: 'SETTINGS_SLA',
  sla_wrapper: 'SETTINGS_SLA',
  // SETTINGS_TEAMS
  settings_teams_add_agents: 'SETTINGS_TEAMS',
  settings_teams_edit: 'SETTINGS_TEAMS',
  settings_teams_edit_finish: 'SETTINGS_TEAMS',
  settings_teams_edit_members: 'SETTINGS_TEAMS',
  settings_teams_finish: 'SETTINGS_TEAMS',
  settings_teams_list: 'SETTINGS_TEAMS',
  settings_teams_new: 'SETTINGS_TEAMS',
  // SUPERVISOR
  teletel_supervisor: 'SUPERVISOR',
});

export const guideKeyForRoute = routeName => PAGE_GUIDES[routeName] ?? null;

// Per-user ui_settings key: true hides the floating launcher (default shown).
// Toggled from Profile settings → Interface; read by PageGuideLauncher.
export const PAGE_GUIDE_HIDDEN_KEY = 'page_guide_launcher_hidden';
